<template>
  <div>
    <vs-table maxHeight="400px" search :data="tankerInRefinery">
      <template slot="header">
        <h5 class="mt-2 mb-5">
          {{ $t("ShipmentTable.Shipment") }} : {{ tableName }}
        </h5>
      </template>
      <template slot="thead">
        <vs-th>
          {{ $t("TankerTable.Id") }}
        </vs-th>
        <vs-th>
          {{ $t("TankerTable.MMSI") }}
        </vs-th>
        <vs-th>
          {{ $t("TankerTable.TankerName") }}
        </vs-th>
        <vs-th>
          {{ $t("TankerTable.Capacity") }}
        </vs-th>
        <vs-th sort-key="volumes">
          {{ $t("TankerTable.TransferVolume") }}
        </vs-th>
        <vs-th sort-key="departed_at_formatted_be">
          {{ $t("TankerTable.TransferStart") }}
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].id">
            {{ indextr + 1 }}
          </vs-td>

          <vs-td :data="getDataByKey(data[indextr], 'vessel.mmsi')">
            {{ getDataByKey(data[indextr], "vessel.mmsi") }}
          </vs-td>

          <vs-td :data="getDataByKey(data[indextr], 'vessel.mmsi')">
            {{ getDataByKey(data[indextr], "vessel.name") }}
          </vs-td>

          <vs-td>
            {{
              formatNumber(
                getCapacity(getDataByKey(data[indextr], "vessel.mmsi", 0))
              )
            }}
          </vs-td>

          <vs-td :data="getDataByKey(data[indextr], 'volumes')">
            {{ getVolume(getDataByKey(data[indextr], "volumes", [])) }}
          </vs-td>

          <vs-td>
            {{ data[indextr].departed_at_formatted_be }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { REFINERY_ID } from "@/constant";
import _ from "lodash";
import { formatNumber } from "@/utils/index";

export default {
  name: "tankerTable",
  data() {
    return {
      tankerInRefinery: [],
      formatNumber,
    };
  },
  mounted() {
    this.changeData(REFINERY_ID[this.tableName]);
    this.$store.dispatch("getMpTankerAll");
  },
  computed: {
    ...mapState({
      tableName: (state) => state.tankerData.tankerName,
      dataTanker: (state) => state.vesselTrip.data,
      dataByDate: (state) => state.vesselTrip.dataByDate,
      mpTankerData: (state) => state.mpTankerData.mpTankerAll,
    }),
  },
  watch: {
    tableName(val, oldval) {
      if (!_.isEqual(val, oldval)) {
        this.changeName(val);
        const refineryId = REFINERY_ID[val] || val;
        this.changeData(refineryId, Boolean(REFINERY_ID[val]));
      }
    },
    dataTanker(val, oldval) {
      if (!_.isEqual(val, oldval)) {
        this.changeData(REFINERY_ID[this.tableName]);
      }
    },
    dataByDate(val, oldval) {
      if (!_.isEqual(val, oldval)) {
        this.changeDataByDate(REFINERY_ID[this.tableName]);
      }
    },
  },
  methods: {
    getDataByKey(data, key, value = "-") {
      return _.get(data, key) || value;
    },
    changeName(val) {
      this.$store.dispatch("setTankerName", val);
    },
    changeData(refineryID, flag = true) {
      let arr = _.filter(this.dataTanker, { station_id: refineryID });
      if (!flag) {
        arr = _.filter(this.dataTanker, { vessel: { name: refineryID } });
      }
      if (arr != 0) {
        this.tankerInRefinery = arr;
      } else this.tankerInRefinery = [];
    },
    changeDataByDate(refineryID) {
      let arr = _.filter(this.dataByDate, { station_id: refineryID });
      if (arr != 0) {
        this.tankerInRefinery = arr;
      } else this.tankerInRefinery = [];
    },
    getVolume(data = []) {
      const value = data.map((val) => {
        return Number(val);
      });
      const sum = value.reduce((a, b) => a + b, 0);
      return formatNumber(sum);
    },
    getCapacity(mmsi) {
      const data = _.find(this.mpTankerData, { mmsi });
      if (data == undefined || data.capacity == null) {
        return 0;
      } else {
        return data.capacity;
      }
    },
  },
};
</script>

<style>
.tableship {
  height: 100%;
}
</style>
